import { createSlice } from "@reduxjs/toolkit";
import {
	prepareDependenciesQuestionsWithRepeatedOnes,
	searchForNodeInTreeAndReplace,
	sortQuestionsByAPIOrder,
} from "utils/helpers";

const initialState = [];

export const slice = createSlice({
	name: "questions",
	initialState,
	reducers: {
		replace: (_state, { payload }) => [
			...(prepareDependenciesQuestionsWithRepeatedOnes({
				questions: [...(sortQuestionsByAPIOrder({ questions: [...(payload || [])] || [] }) || [])],
			}) || []),
		],
		append: (state, { payload }) => [...state, ...payload],
		replaceQuestion: (state, { payload: { question, allowFindByIndex = false } }) => [
			...(searchForNodeInTreeAndReplace({ list: [...(state || [])], single: question, allowFindByIndex }) || []),
		],
		delete: () => initialState,
	},
});

export const questionsSelector = (state) => state?.questions || [];

export const { actions, reducer } = slice;

export default reducer;
